<template>
    <nav class="pagination is-centered is-rounded" role="navigation" aria-label="pagination">
        <a class="pagination-previous" @click.prevent="changePage(1)" :disabled="pagination.current_page <= 1">{{ $t('common.ກັບໜ້າທຳອິດ') }}</a>
        <a class="pagination-previous" @click.prevent="changePage(pagination.current_page - 1)" :disabled="pagination.current_page <= 1">{{ $t('common.ກ່ອນຫນ້າ') }}</a>
        <a class="pagination-next" @click.prevent="changePage(pagination.current_page + 1)" :disabled="pagination.current_page >= pagination.last_page">{{ $t('common.ຖັດໄປ') }}</a>
        <a class="pagination-next" @click.prevent="changePage(pagination.last_page)" :disabled="pagination.current_page >= pagination.last_page">{{ $t('common.ໄປໜ້າສຸດທ້າຍ') }}</a>
        <ul class="pagination-list">
            <li v-for="(page, index) in pages" :key="index">
                <a class="pagination-link" :class="isCurrentPage(page) ? 'is-current' : ''" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    props: ['pagination', 'offset'],

    methods: {
       isCurrentPage(page) {
            return this.pagination.current_page === page;
        },
        changePage(page) {
            if (page > this.pagination.last_page) {
                page = this.pagination.last_page;
            }
            if (page < 1) {
                page = 1;
            }
            // Update pagination for backward compatibility with components that rely on prop mutation
            this.pagination.current_page = page;
            // Also emit page number for components that accept parameters
            this.$emit('paginate', page);
        },
    },
    computed: {
        pages() {
            let pages = [];
            let from = this.pagination.current_page - Math.floor(this.offset / 2);

            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset - 1;
            if (to > this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            while (from <= to) {
                pages.push(from);
                from++;
            }
            return pages;
        }
    }
}
</script>
